import {
  CustomizationDataDto,
  TableColumnConfigDto,
} from '@asset-metrix/portal-gateway-client-js';

/**
 * Converts customizedColumns from TableContent to CustomizationDataDto for excel export.
 *
 * In group-only mode, patchColumnsForGroupOnlyMode strips grouping from all columns
 * for AG Grid rendering. The optional groupByColumnId restores grouping on the
 * selected column so the backend can build the correct grouping request.
 */
export function convertToCustomizationData(
  customizedColumns: TableColumnConfigDto[],
  groupByColumnId?: string
): CustomizationDataDto {
  return {
    columns: customizedColumns.map((col) => {
      const grouping = col.grouping ?? (col.id === groupByColumnId ? 0 : null);

      return {
        columnId: col.id,
        visible: grouping != null ? true : !col.hidden,
        fixed: col.freeze ?? false,
        grouping,
      };
    }),
  };
}
